export default __webpack_public_path__ + "static/media/rails.26d18a6e.svg";